import { useState, useContext } from "react";
import { IconButton, Menu, MenuItem, Box } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { ToolContext } from "../../../../../core/context/ToolContext";

export const FileActions = ({ type, id, file, existing_file, currentStatus }) => {
    const { realproperty_state } = useContext(ToolContext)
    const { fileTypes, requirements } = realproperty_state

    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleAddFiles = (e) => {
        const file = Array.from(e.target.files);
        const validExt = ['pdf', 'doc', 'docx'];
        const ext = file[0].name.split('.').pop().toLowerCase();
        const name = file[0].name.split('.');
        name.pop();
        const file_name = name.join('.'); 
        if (!validExt.includes(ext)) {
            alert('Error! Only PDF or Word documents are allowed (.pdf, .doc, .docx).')
            return;
        }
        const f = { file: [file[0]], file_name, ext }
        fileTypes.set((p) => ({
            ...p,
            [type]: p[type].map((v) => {
                if (v.id !== id) return v;
                const { existing_file, ...rest } = v;
                return { ...rest, file: f };
                // v.id === id ? { ...v, file: f } : v
            })
        }))
        requirements.set((p) => ({ ...p, error: false }))
        handleClose();
    };
    
    const removeFile = () => {
        fileTypes.set((p) => ({
            ...p,
            [type]: p[type].map((v) => {
                if (v.id !== id) return v;
                const { file, existing_file, ...rest } = v;
                return rest;
            })
        }))
        handleClose();
    }

    const viewFile = () => {
        if (existing_file?.link) {
            window.open(existing_file?.link, '_blank')
        } else {
            window.open(URL.createObjectURL(file.file[0]), '_blank')
        }
    }

    return (
        <>
            <IconButton onClick={handleOpen} sx={{ color: 'primary.main', width: 24, height: 24, p: 0 }}>
                <MoreHoriz sx={{ width: 18, height: 18, cursor: 'pointer', ':hover': { color: "grey" } }} />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} sx={{ '& .MuiPaper-root': { borderRadius: '8px', backgroundColor: '#FFF', boxShadow: '0 4px 8px rgba(0,0,0,0.12)'} }}>
                { currentStatus !== 'deal-closed' && 
                    <MenuItem component="label" sx={{ fontSize: '12px', cursor: 'pointer' }}>
                        Upload
                        <Box component='input' type="file" accept='.pdf,.doc,.docx' hidden onChange={(e) => handleAddFiles(e)}/>
                    </MenuItem>
                }
                {(file || existing_file) && [
                    currentStatus !== 'deal-closed' && (
                        <MenuItem key="remove" sx={{ fontSize: '12px', cursor: 'pointer' }} onClick={removeFile}>
                            Remove
                        </MenuItem>
                    ),
                    <MenuItem key="view" sx={{ fontSize: '12px', cursor: 'pointer' }} onClick={viewFile}>
                        View
                    </MenuItem>
                ]}
            </Menu>
        </>
    );
};
